export const SUCCESS_FLAG_ACTION_VIEW_ISSUE = 'viewIssues';
export const SUCCESS_FLAG_ACTION_COPY_LINK = 'copyLink';
export const SUCCESS_FLAG_ACTION_ADD_TO_SPRINT = 'addToSprint';
export const SUCCESS_FLAG_ACTION_CLEAR_FILTERS = 'clearFilters';
